<div class="component-container mat-elevation-z10 need-more-help-container" (click)="openNeedMoreHelpModal()">
  <span class="material-symbols-outlined">help_outline</span>
  <h2 class="help-text">
    {{buttonLabel || "I need more help"}}
  </h2>
</div>